import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Alert, CircularProgress } from "@mui/material";
import { T } from "../../../admin.theme";
import { Panel } from "../../../ui";
import { useAbout, useDeleteAboutBlock5Slot, useDeleteAboutBlockImage, useSaveAbout, useSetAboutBlock5Slot, useSetAboutBlockImage, } from "../model/hooks";
import { AboutEditorView } from "./AboutEditorView";
var BLOCK_N = { block2: 2, block3: 3, block4: 4 };
// Live editor for an existing collection: texts persist on "Save texts" (PUT),
// images upload immediately to their fixed block/slot endpoints.
export var AboutEditor = function (_a) {
    var collectionId = _a.collectionId;
    var _b = useAbout(collectionId), about = _b.data, isLoading = _b.isLoading, isError = _b.isError;
    var _c = useSaveAbout(collectionId), save = _c.mutate, saving = _c.isPending;
    var _d = useSetAboutBlockImage(collectionId), setBlockImage = _d.mutate, settingImg = _d.isPending;
    var deleteBlockImage = useDeleteAboutBlockImage(collectionId).mutate;
    var _e = useSetAboutBlock5Slot(collectionId), setSlotImage = _e.mutate, settingSlot = _e.isPending;
    var deleteSlotImage = useDeleteAboutBlock5Slot(collectionId).mutate;
    var _f = useState(null), form = _f[0], setForm = _f[1];
    var _g = useState(false), saved = _g[0], setSaved = _g[1];
    var _h = useState(null), saveError = _h[0], setSaveError = _h[1];
    var initedFor = useRef(null);
    useEffect(function () {
        if (about && initedFor.current !== collectionId) {
            // Инициализация редактируемой формы загруженным контентом — намеренно.
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setForm(structuredClone(about));
            initedFor.current = collectionId;
        }
    }, [about, collectionId]);
    if (isLoading || !form) {
        return (_jsx(Panel, { style: { display: "flex", justifyContent: "center", padding: 48 }, children: _jsx(CircularProgress, { sx: { color: T.accent } }) }));
    }
    if (isError) {
        return _jsx(Alert, { severity: "error", variant: "outlined", children: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0435\u043D\u0442 About." });
    }
    return (_jsx(AboutEditorView, { value: form, onChange: setForm, getBlockImage: function (key) { var _a; return ({ url: (_a = about === null || about === void 0 ? void 0 : about[key].imageUrl) !== null && _a !== void 0 ? _a : null, busy: settingImg }); }, onUploadBlockImage: function (key, file) { return setBlockImage({ n: BLOCK_N[key], file: file }); }, onDeleteBlockImage: function (key) { return deleteBlockImage(BLOCK_N[key]); }, getSlotImage: function (index) { var _a, _b; return ({ url: (_b = (_a = about === null || about === void 0 ? void 0 : about.block5.items[index]) === null || _a === void 0 ? void 0 : _a.imageUrl) !== null && _b !== void 0 ? _b : null, busy: settingSlot }); }, onUploadSlot: function (index, file) { return setSlotImage({ slot: (index + 1), file: file }); }, onDeleteSlot: function (index) { return deleteSlotImage((index + 1)); }, onSaveTexts: function () {
            setSaved(false);
            setSaveError(null);
            save(form, {
                onSuccess: function () { return setSaved(true); },
                onError: function (e) {
                    var _a, _b;
                    return setSaveError(((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                        "Не удалось сохранить. Проверьте длину полей (см. ограничения) и повторите.");
                },
            });
        }, saving: saving, saved: saved, saveError: saveError, onDismissSaved: function () { return setSaved(false); }, onDismissError: function () { return setSaveError(null); } }));
};
